import { services, articles, articleCategories, allTimeSlots } from './staticData';

async function mockGet(url) {
  if (url === '/services') return services;
  if (url.startsWith('/articles/categories')) return articleCategories;
  if (url.startsWith('/articles/detail/')) {
    const slug = url.replace('/articles/detail/', '');
    const article = articles.find(a => a.slug === slug);
    if (!article) throw { response: { status: 404 } };
    const related = articles.filter(a => a.category === article.category && a.slug !== slug && a.status === 'published').slice(0, 3);
    return { ...article, related };
  }
  if (url.startsWith('/articles')) {
    const params = new URLSearchParams(url.includes('?') ? url.split('?')[1] : '');
    let filtered = articles.filter(a => a.status === 'published');
    const search = params.get('search');
    const category = params.get('category');
    if (search) filtered = filtered.filter(a => a.title.toLowerCase().includes(search.toLowerCase()));
    if (category) filtered = filtered.filter(a => a.category === category);
    const page = parseInt(params.get('page') || '1');
    const limit = parseInt(params.get('limit') || '12');
    return { articles: filtered.slice((page - 1) * limit, page * limit), total: filtered.length, page, pages: Math.max(1, Math.ceil(filtered.length / limit)) };
  }
  return [];
}

const api = {
  get: async (url) => ({ data: await mockGet(url) }),
  post: async (url, body) => ({ data: { message: 'Başarılı', ...body } }),
  put: async () => ({ data: { message: 'Güncellendi' } }),
  delete: async () => ({ data: { message: 'Silindi' } }),
};

export default api;
